export const environment = {
  production: true,
  development: false,
  test: false,
  url: 'https://proconnect.loreal.pl',
  api: 'https://proconnect.loreal.pl/api',
  recaptchaV3SiteKey: '6LfYZzgqAAAAAP_IfNfWImqknq4EG7D4CGmyKShe',
  oneScriptDataDomainKey: '0193af92-82af-72a9-986b-95b866e8d782',
  gtm: 'GTM-TTCR9PHG',
};
